<template>
  <div class="modelview">
    <model-viewer :src="'./models/'+vtype+'.glb'" alt="A 3D model of an astronaut" auto-rotate camera-controls ar ar-modes="webxr scene-viewer quick-look" ar-scale="auto"></model-viewer>
  </div>
</template>

<script>
import '@google/model-viewer'

export default {
  name: 'ModelView',
  props: {
    vtype: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modelview {
  width: 100%;
  height: 330px;
}

.modelview model-viewer{
  width: 100%;
  height: 100%;

  outline: none;
}


</style>
